 
import '../App.css';
import React from 'react';
 
import firebase, { auth, provider } from '../firebase.js';
 
 import Editor from "./editor"
 
import { signInAuthProvider} from "./authProvider";
import { AzureAD, AuthenticationState } from 'react-aad-msal';
import jwt_decode from "jwt-decode";

 

const badges={

 
  coinSystem: require( "../imgs/badges/brs/BR - System Integrator.png"),
coinScripting: require ("../imgs/badges/brs/BR - Scripting.png"),
coinHost: require ("../imgs/badges/brs/BR - Host Analyst.png"),
 coinNetwork:  require ("../imgs/badges/brs/BR - Network Analyst.png"),
 coinPowerShell:  require ( "../imgs/badges/brs/BR - PowerShell Fundamentals.png"),
 coinIntel:  require ( "../imgs/badges/brs/BR - Intel Analyst.png"),
 coinLinux:  require ( "../imgs/badges/brs/BR - Linux Basics.png"),
coinTraffic:  require ( "../imgs/badges/brs/BR - Network Packet Analysis.png"),
 coinForensics: require ("../imgs/badges/brs/BR - Forensics One.png"),

 coinHerd: require ("../imgs/badges/missions/M1 - Goat Herd.png"),
 coinWolf: require ("../imgs/badges/missions/M10 - Crimson Wolf.png"),
 coinHermit: require ("../imgs/badges/missions/M12 - Bold Hermit.png"),
 coinDragon: require ("../imgs/badges/missions/M13 - Black Dragon.png"),
 coinBear: require ("../imgs/badges/missions/M2 - Bear Treat.png"),
 coinWhale: require ("../imgs/badges/missions/M3 - Desert Whale.png"),
 coinCobra: require ("../imgs/badges/missions/M4 - Arctic Cobra.png"),
 coinWBear: require ("../imgs/badges/missions/M5 - Wounded Bear.png"),
 coinTiger: require ("../imgs/badges/missions/M6 - Angry Tiger.png"),
 coinOcean: require ("../imgs/badges/missions/M8 - Ocean View.png"),
 coinWFlash: require ("../imgs/badges/missions/M9 - Waterfall Flash.png"),
 coinWBear: require ("../imgs/badges/missions/M5 - Wounded Bear.png"), 
 coinBR22: require ("../imgs/badges/brs/BR - MS Cloud App Security.png"), 
 coinBR29: require ("../imgs/badges/brs/br29.png"), 

 coinCTF1: require ("../imgs/badges/brs/BR - CTF1.png"),
 coinCTF2: require ("../imgs/badges/brs/BR - CTF2.png"),
 coinCTF3:require ("../imgs/badges/brs/BR - CTF3.png"),
 coinCTF4: require ("../imgs/badges/brs/BR - CTF4.png"),
 coinCTF5: require ("../imgs/badges/brs/BR - CTF5.png"),



};

const db = firebase.firestore();

var storageRef = firebase.storage().ref();


 
class Auth extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      msalProvider:signInAuthProvider()

    };
 
   
  }

 

  render() {
    return (

        <AzureAD provider={this.state.msalProvider} >
    {
    ({login, logout, authenticationState, error, accountInfo}) => {
      switch (authenticationState) {
        case AuthenticationState.Authenticated:
          return (
            jwt_decode(accountInfo.jwtIdToken).extension_Username.split('@')[1]==='circadence.com'?           this.props.authenticated:""
        
          );
        case AuthenticationState.Unauthenticated:
          return null
        case AuthenticationState.InProgress:
          return null
      }
    }
  }
      </AzureAD>
    )
  }

}








class ScenarioCatalog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      editor: false,
    };
  }

  componentDidMount() {
    console.log("catalog", this.props);

    /*  const location = window.location.pathname.split("/");
   this.scenarioToState(location[location.length-1])
 console.log(this.props.scenarios[this.props.active.toLowerCase()])*/
  }

  render() {
    return (
      <div className="scenario-wrapper" id={this.props.active}>
        {this.props.dif ? (
          <>
            {this.props.scenarios[this.props.active.toLowerCase()] ? (
              <div className="table-col">
                {badges[
                  this.props.scenarios[this.props.active.toLowerCase()].coin
                ] ? (
                  <img
                    alt="badge"
                    src={
                      badges[
                        this.props.scenarios[this.props.active.toLowerCase()]
                          .coin
                      ].default
                    }
                  />
                ) : (
                  <img alt="badge" src={badges.coinSystem.default} />
                )}
                <table>
                  <tbody>
                    {this.props.dif == "m" ? (
                      <>
                        <tr>
                          <td>Load Time </td>
                          <td>
                            {
                              this.props.scenarios[
                                this.props.active.toLowerCase()
                              ].loadm
                            }
                          </td>
                        </tr>
                      </>
                    ) : (
                      <tr>
                        <td>Load Time </td>
                        <td>
                          {
                            this.props.scenarios[
                              this.props.active.toLowerCase()
                            ].load
                          }
                        </td>
                      </tr>
                    )}

{this.props.dif == "m" &&  this.props.scenarios[
                                this.props.active.toLowerCase()
                              ].timem ? (
                      <>
                        <tr>
                          <td>Time Limit </td>
                          <td>
                            {
                              this.props.scenarios[
                                this.props.active.toLowerCase()
                              ].timem
                            }
                          </td>
                        </tr>
                      </>
                    ) : (
                      <tr>
                        <td>Time Limit </td>
                        <td>
                          {
                            this.props.scenarios[
                              this.props.active.toLowerCase()
                            ].time
                          }
                        </td>
                      </tr>
                    )}


            
                    <tr>
                      <td># of Tasks</td>
                      <td>
                        {
                          this.props.scenarios[this.props.active.toLowerCase()]
                            .tasks
                        }
                      </td>
                    </tr>
                    <tr>
                      <td>Hints</td>
                      <td>
                        {
                          this.props.scenarios[this.props.active.toLowerCase()]
                            .hints
                        }
                      </td>
                    </tr>
                    <tr>
                      <td>Save Session</td>
                      <td>
                        {
                          this.props.scenarios[this.props.active.toLowerCase()]
                            .save
                        }
                      </td>
                    </tr>
                    <tr>
                      <td>Team Based</td>
                      <td>
                        {
                          this.props.scenarios[this.props.active.toLowerCase()]
                            .team
                        }
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            ) : (
              "no josh data"
            )}
      {this.props.scenarios[this.props.active.toLowerCase()] ?  <div className="scenario-info">
    
         {this.props.links}
     
 
          {this.props.scenarios[this.props.active.toLowerCase()].offensive ? (
            <h2
              className={this.props.scenarios[this.props.active.toLowerCase()].offensive == "true" ? "off" : "def"}
            >
              {this.props.scenarios[this.props.active.toLowerCase()].offensive == "true" ? "Offensive" : "Defensive"}
            </h2>
          ) : (
            ""
          )}
<br/>
<button className="flat-button print"  onClick={()=>window.print()}><svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M0 0h24v24H0z" fill="none"/><path d="M19 8H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zm-3 11H8v-5h8v5zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-9H6v4h12V3z"/></svg></button>


{/* <Auth authenticated={ <button className="flat-button edit"  onClick={()=>this.setState({editor:!this.state.editor})}>
         <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" viewBox="0 0 24 24"  width="18px" height="18px"><g><rect fill="none" height="24" width="24"/></g><g><g><g><polygon points="3,17.25 3,21 6.75,21 17.81,9.94 14.06,6.19"/></g><g><path d="M20.71,5.63l-2.34-2.34c-0.39-0.39-1.02-0.39-1.41,0l-1.83,1.83l3.75,3.75l1.83-1.83C21.1,6.65,21.1,6.02,20.71,5.63z"/></g></g></g></svg>
         </button>}/> */}



{this.props.scenarios[this.props.active.toLowerCase()].video?<iframe src={"https://player.vimeo.com/video/"+this.props.scenarios[this.props.active.toLowerCase()].video.split("/")[3]+"?title=0&byline=0&portrait=0"} width="720" height="405" frameBorder="0" allow="autoplay; fullscreen" allowFullScreen=""></iframe>:""
    }   


 <br/> <br/>
      
     {this.props.scenarios[this.props.active.toLowerCase()].overview && <ul className="objectives">    <li className="expanded">
                                  <span
                                    onClick={(event) => {
                                      event.stopPropagation();
                                      event.target.parentNode.parentNode.classList.toggle(
                                        "expanded"
                                      );
                                    }}
                                  >
                                    <h4>
                                    Scenario overview:
                                    </h4>
                                  
                                  </span>
  
                                  <div className="content">
                                  
                                  {this.state.editor?     <Editor field="overview" content={this.props.scenarios[this.props.active.toLowerCase()].overview} write={this.props.write} active={this.props.active}/>:
          <p dangerouslySetInnerHTML={{ __html:this.props.scenarios[this.props.active.toLowerCase()].overview}}></p>}

                                    </div></li>
                                      
                                   </ul>}


 
{this.props.scenarios[this.props.active.toLowerCase()].success && <ul className="objectives">    <li>
                                  <span
                                    onClick={(event) => {
                                      event.stopPropagation();
                                      event.target.parentNode.parentNode.classList.toggle(
                                        "expanded"
                                      );
                                    }}
                                  >
                                    <h4>
                                    How to be successful:
                                    </h4>
                                  
                                  </span>
  
                                  <div className="content">
                                  
                                  {this.state.editor?  <Editor field="success" content={this.props.scenarios[this.props.active.toLowerCase()].success} write={this.props.write} active={this.props.active}/>:
          <p dangerouslySetInnerHTML={{ __html:this.props.scenarios[this.props.active.toLowerCase()].success}}></p>}



                                    </div></li>
                                      
                                   </ul>}



 
 {this.props.scenarios[this.props.active.toLowerCase()].prior && <ul className="objectives">    <li>
                                  <span
                                    onClick={(event) => {
                                      event.stopPropagation();
                                      event.target.parentNode.parentNode.classList.toggle(
                                        "expanded"
                                      );
                                    }}
                                  >
                                    <h4>
                                    What you should know prior:
                                    </h4>
                                  
                                  </span>
  
                                  <div className="content">
                                  
                                  {this.state.editor?     <Editor field="prior" content={this.props.scenarios[this.props.active.toLowerCase()].prior} write={this.props.write} active={this.props.active}/>:
          <p dangerouslySetInnerHTML={{ __html:this.props.scenarios[this.props.active.toLowerCase()].prior}}></p>}    
                                    </div></li>
                                      
                                   </ul>}




          {this.props.scenarios[this.props.active.toLowerCase()].instructions && <ul className="objectives">    <li>
                                  <span
                                    onClick={(event) => {
                                      event.stopPropagation();
                                      event.target.parentNode.parentNode.classList.toggle(
                                        "expanded"
                                      );
                                    }}
                                  >
                                    <h4>
                                    Scenario Instructions:
                                    </h4>
                                  
                                  </span>
  
                                  <div className="content">
                                  

                                  {this.state.editor?     <Editor field="instructions" content={this.props.scenarios[this.props.active.toLowerCase()].instructions} write={this.props.write} active={this.props.active}/>:<span dangerouslySetInnerHTML={{ __html:this.props.scenarios[this.props.active.toLowerCase()].instructions}}></span>}
                                    
                                    </div></li>
                                      
                                   </ul>}
                                 
 
        </div>:<>  {this.props.links}no josh data</>}





            <div className="aid-wrapper">{this.props.hints}</div>
          </>
        ) : (
          "loading catalog"
        )}
      </div>
    );
  }
}

export default ScenarioCatalog;
